import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Privilege, User } from '../../clients/aasServerClient.generated';
import { adEnabled, getAssignablePrivileges } from '../../stores/auth/selectors';
import { RootState } from '../../stores/store';
import FormInput from '../common/FormInput';

interface Props extends LocalizeContextProps {
    type: 'edit' | 'new';
    user: Partial<User>;
    updateUser: (user: Partial<User>) => void;

    assignable: Array<{ name: string }>;
    adEnabled?: boolean;
}

class UserProperties extends React.Component<Props, Partial<User>> {

    public constructor(props: Props) {
        super(props);
        this.state = props.user;
        this.props.updateUser(this.state);
    }

    public render() {
        const t = this.props.translate;
        return (
            <React.Fragment>
                {this.props.type === 'edit' ? (
                    <FormInput
                        row={true}
                        name="id"
                        fullName={t('users.edit.field.id') as string}
                        value={this.state.id || ''}
                        disabled={true}
                        readOnly={true}
                    />
                ) : null}
                {this.props.adEnabled ? (
                    <FormInput
                        row={true}
                        name="ad_identifier"
                        fullName={t('users.edit.field.adIdentifier') as string}
                        value={this.state.ad_identifier || ''}
                        onChange={this.handleUserChange}
                        disabled={(this.props.user.ad_identifier || '') !== ''}
                    />
                ) : null}
                <FormInput
                    row={true}
                    name="email"
                    fullName={t('users.edit.field.email') as string +'*'}
                    value={this.state.email || ''}
                    onChange={this.props.type == 'edit' && !this.props.adEnabled ?
                        () => { } : this.handleUserChange}
                    disabled={this.props.type == 'edit' && !this.props.adEnabled}
                />
                <FormInput
                    row={true}
                    name="first_name"
                    fullName={t('users.edit.field.firstName') as string +'*'}
                    value={this.state.first_name || ''}
                    onChange={this.handleUserChange}
                />
                <FormInput
                    row={true}
                    name="last_name"
                    fullName={t('users.edit.field.lastName') as string +'*'}
                    value={this.state.last_name || ''}
                    onChange={this.handleUserChange}
                />
                <FormInput
                    row={true}
                    name="org_unit"
                    fullName={t('users.edit.field.orgUnit') as string}
                    value={this.state.org_unit || ''}
                    onChange={this.handleUserChange}
                />
                <FormInput
                    row={true}
                    name="active"
                    type="checkbox"
                    fullName={t('users.edit.field.active') as string}
                    checked={this.state.active ?? false}
                    checkboxProp={true}
                    onChange={this.handleUserChange}
                />
                {this.props.type === 'edit' ? (
                    <span><i>{t('users.edit.field.lastLogin')}{this.state.last_login ?
                        (new Date(this.state.last_login)).toLocaleString()
                        : t('users.edit.field.lastLoginNever')}</i></span>
                ) : null}
            </React.Fragment>
        );
    }

    private handleUserChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.name === 'email') {
            e.target.value = e.target.value.trim();
        }
        const update = {
            [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value,
        };
        this.setState(update);
        this.props.updateUser({ ...this.state, ...update });
    }
}

const mapStateToProps = (state: RootState) => ({
    adEnabled: adEnabled(state),
    assignable: getAssignablePrivileges(state),
});

export default connect(mapStateToProps)(withLocalize(UserProperties));